import React from "react";

import Container, { ContainerSize } from "../../design-system/Container";
import LinkCard from "../../design-system/LinkCard";
import CombinedHeader from "../../design-system/PageHeader/CombinedHeader";

export default function OrganisationPage() {
  return (
    <Container size={ContainerSize.Small}>
      <CombinedHeader title="Organisations data" />
      <LinkCard text="Question data" to={`/organisations-data/question-data`} />
    </Container>
  );
}
